import React from 'react';
import ScreenWrapper from '../features/Theme/ScreenWrapper';
import OrderExecutionPolicy from '../features/LegalDocuments/OrderExecutionPolicy';

type Props = {
    setActiveRightTab?: Function;
};

export default function OrderExecutionPolicyScreen({ setActiveRightTab }: Props) {
    return (
        <ScreenWrapper>
            <OrderExecutionPolicy setActiveRightTab={setActiveRightTab} />
        </ScreenWrapper>
    );
}
